import type { FaireProductEntity } from "../../entity_types/product";

export const search_continuous_12: FaireProductEntity = {
  token: "search_continuous_12",
  type: "product",
  name: "Green Check Ceramic Mug",
  brandName: "State The Label",
  brandToken: "state-the-label",
  imageUrl: "",
  priceDollars: 12.0,
  msrpDollars: 16.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
